/**
 * Visages d'une satisfaction notée en smileys, du plus mécontent au plus satisfait, selon le nombre
 * de crans qu'elle propose.
 *
 * Ce sont les dessins maison de Vocaza, et non ceux d'ant-design : le répondant les connaît déjà,
 * l'éditeur doit montrer les mêmes. `nz-icon` les charge à la demande depuis
 * `public/assets/vocaza-icons/`, d'où l'espace de noms porté par le nom. Ils sont tracés en
 * `currentColor` : la couleur du cran les habille.
 *
 * Une échelle paire n'a pas de milieu où se ranger : le visage neutre n'y figure pas, on est d'un
 * côté ou de l'autre. La répartition est celle du questionnaire publié, reprise à l'identique.
 */
export const SMILEY_PALETTES: Record<number, string[]> = {
    4: ['vocaza-icons:very-sad', 'vocaza-icons:sad', 'vocaza-icons:smile', 'vocaza-icons:very-smile'],
    5: [
        'vocaza-icons:very-sad',
        'vocaza-icons:sad',
        'vocaza-icons:neutral',
        'vocaza-icons:smile',
        'vocaza-icons:very-smile',
    ],
    11: [
        'vocaza-icons:very-sad',
        'vocaza-icons:very-sad',
        'vocaza-icons:very-sad',
        'vocaza-icons:very-sad',
        'vocaza-icons:neutral',
        'vocaza-icons:neutral',
        'vocaza-icons:neutral',
        'vocaza-icons:very-smile',
        'vocaza-icons:very-smile',
        'vocaza-icons:very-smile',
        'vocaza-icons:very-smile',
    ],
};

/** Une échelle d'étoiles se compte, elle ne se lit pas : toutes ses étoiles sont la même. */
export const STAR_ICON = 'vocaza-icons:star';

/** Visage sans opinion, celui d'une échelle dont la longueur ne correspond à aucune palette. */
export const NEUTRAL_SMILEY = 'vocaza-icons:neutral';
